import React from "react";
import { Button } from "@material-ui/core";
import * as Constants from "../../../../constants/Constants";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";

class AssignRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onAssignChange = (selectedVendor) => {
    this.props.onAssignChange(selectedVendor);
  };

  render() {
    return (
      <Button
        id="assignButton"
        className={
          this.props.row.id === this.props.selectedRowId &&
          getUserRolePermission(
            RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_NEWVENDORS,
            RolePermissionConstants.VMP_ASSIGN
          ) === RolePermissionConstants.EDIT
            ? "btn-Assign"
            : "btn-Assign-Disable"
        }
        onClick={() => this.onAssignChange(this.props.row)}
        disabled={this.props.row.id === this.props.selectedRowId ? false : true}
      >
        {Constants.ASSIGN}
      </Button>
    );
  }
}

export default AssignRenderer;
